var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0302 5.62558C16.5577 5.1531 15.7916 5.15317 15.319 5.62572L11.3281 9.61668L7.41347 5.70209C6.94099 5.22962 6.17489 5.22968 5.70233 5.70224C5.22978 6.17479 5.22971 6.9409 5.70219 7.41338L9.61677 11.328L5.62582 15.3189C5.15326 15.7915 5.1532 16.5576 5.62568 17.0301C6.09816 17.5025 6.86426 17.5025 7.33682 17.0299L11.3278 13.039L15.2423 16.9535C15.7148 17.426 16.4809 17.426 16.9535 16.9534C17.426 16.4808 17.4261 15.7147 16.9536 15.2423L13.0391 11.3277L17.03 7.33672C17.5026 6.86417 17.5026 6.09806 17.0302 5.62558Z",
    fill: "#898A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ce8bd5c7eb82716e4e1b53192dc8f2ec.svg";
export { ForwardRef as ReactComponent };